import classNames from 'classnames'
import { FC, ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageBackLink } from 'src/components/PageBackLink'
import styles from './layout.module.scss'

interface AiListeningPageProps {
  children: ReactNode
  className?: string
}

// The content column every AI Listening screen sits in.
export const AiListeningPage: FC<AiListeningPageProps> = ({
  children,
  className,
}) => <div className={classNames(styles.page, className)}>{children}</div>

interface PageBreadcrumbProps {
  // Where the chevron goes; omitted = back in history, or `fallbackTo` when
  // the page was opened directly (no in-app history to go back to).
  backTo?: string
  fallbackTo?: string
  items: string[]
}

// "← AI Listening / Brand Profiles" over the page's own title: the last item
// names the current page, which the title under it already says.
export const PageBreadcrumb: FC<PageBreadcrumbProps> = ({
  backTo,
  fallbackTo,
  items,
}) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleClick = () => {
    if (backTo) {
      navigate(backTo)
    } else if (location.key === 'default' && fallbackTo) {
      navigate(fallbackTo)
    } else {
      navigate(-1)
    }
  }

  const parents = items.length > 1 ? items.slice(0, -1) : items

  return (
    <PageBackLink
      className={styles.breadcrumb}
      label={parents.join(' / ')}
      onClick={handleClick}
    />
  )
}

interface PageTitleRowProps {
  children?: ReactNode
  title: ReactNode
}

// Page heading with an optional right-hand slot (tabs, actions).
export const PageTitleRow: FC<PageTitleRowProps> = ({ children, title }) => (
  <div className={styles.titleRow}>
    <h1 className={styles.title}>{title}</h1>
    {children}
  </div>
)
